import { localStorage } from 'dibs-browser-storage';

const TRADE_ENROLLMENT_AND_STATUS_UPDATE_VIEWS = 'TRADE_ENROLLMENT_AND_STATUS_UPDATE_VIEWS';

const getViewCount = (): number =>
    localStorage.getItem(TRADE_ENROLLMENT_AND_STATUS_UPDATE_VIEWS) || 0;

export function hasSeenEnrollmentAndStatusUpdate(): boolean {
    return getViewCount() > 0;
}

export function logEnrollmentAndStatusUpdateView(): void {
    localStorage.setItem(TRADE_ENROLLMENT_AND_STATUS_UPDATE_VIEWS, getViewCount() + 1);
}
